/* @flow */
import * as React from 'react';

import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import Glyph from 'components/Glyph.jsx';
import MediaObject from 'components/MediaObject.jsx';
import MenuButton from 'components/MenuButton.jsx';
import Text from 'components/Text.jsx';
import TextWithEntities from 'components/TextWithEntities.jsx';
import Time from 'components/Time.jsx';

import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import TextEntities from 'lib/TextEntities';

import type { RosterGroupSummary } from './SetupRosterConfirm';

export default class SetupConfirmClassesListItem extends React.Component<{
  group: RosterGroupSummary,
  menu: Object,
}> {
  renderGroupName() {
    const groupName = this.props.group.className;
    const entities = TextEntities.parseEmoji(groupName);
    return <TextWithEntities text={groupName} entities={entities} />;
  }

  renderSubtext() {
    const { group } = this.props;

    return (
      <Text color="thunder" element="div" size="xxsmall">
        {group.code && `${group.code} • `}
        {'Created '}
        <Time date={new Date(group.createdAt)} month="numeric" day="numeric" year="numeric" />
      </Text>
    );
  }

  render() {
    const { group, menu } = this.props;

    return (
      <MediaObject center figure="right" gutter="xsmall" className="SetupConfirmClassesListItem">
        <MediaObject center>
          <GroupAvatar group={group} size="medium" />
          <div>
            <Text color="pitch" size="xsmall" weight="semibold">
              {this.renderGroupName()}
            </Text>
            {this.renderSubtext()}
          </div>
        </MediaObject>
        <Buttons>
          {group.kind === 'proposedGroup' && (
            <Button
              aria-label="New classes from your school database are added to your Remind account automatically"
              tooltip="New classes from your school database are added to your Remind account automatically"
              tooltipPlacement="top"
              color="shamrock"
              weight="normal"
              level="icon">
              <Text size="xxxsmall" smallCaps weight="normal">
                NEW
              </Text>
            </Button>
          )}
          {group.hasRosterSource && (
            <Button
              className="SetupConfirmClassesListItem-link"
              aria-label="Linked Remind classes are updated directly from your school’s database"
              tooltip="Linked Remind classes are updated directly from your school’s database"
              tooltipPlacement="top"
              color="shamrock"
              level="icon">
              <Glyph name="link" size="large" solo />
            </Button>
          )}
          <MenuButton
            className="SetupConfirmClassesListItem-menuButton"
            alignment="right"
            placement="bottom"
            menu={menu}
            size="small"
            level="icon">
            <Glyph name="ellipses" size="large" solo />
          </MenuButton>
        </Buttons>
      </MediaObject>
    );
  }
}
